import { getOWAConnectedAccounts } from 'owa-accounts-store';
import { getUserMailboxInfo } from 'owa-client-ids';

/**
 * Get email addresses for all the connected accounts
 */
export default function getEmailAddressForAllAccounts(): string[] {
    return [getUserMailboxInfo().userIdentity].concat(
        getOWAConnectedAccounts().map(account => account.userIdentity)
    );
}
